'use client'

import LogoutIcon from '@mui/icons-material/Logout'
import { ButtonBase, Menu, MenuItem, Stack, Typography } from '@mui/material'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import { fetchUserAttributes, signOut, getCurrentUser } from 'aws-amplify/auth'
import Link from 'next/link'
import { PATH_ACCOUNT } from '@/utils/pageRoutes'

export const UserProfile = () => {
  const [account, setAccount] = useState({ name: '', email: '' })

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    async function getMfaType() {
      const user = await getCurrentUser()
      const attributes = await fetchUserAttributes()
      setAccount({
        ...account,
        name: user.username || '',
        email: attributes.email || '',
      })
    }
    getMfaType()
  }, [])

  return (
    <>
      {/* <LoadingBackdrop isOpen={isLoading} /> */}
      <ButtonBase sx={{ display: 'flex', gap: 2 }} onClick={handleClick}>
        <Stack textAlign='left'>
          <Typography color='#111111' fontWeight={500} fontSize={14}>
            {account.name}
          </Typography>
          <Typography color='rgba(17, 17, 17, 0.6)' fontSize={12}>
            {account.email}
          </Typography>
        </Stack>
        {open ? (
          <Image src='/chevron-up.svg' width={16} height={16} alt='chevron' />
        ) : (
          <Image src='/chevron-down.svg' width={16} height={16} alt='chevron' />
        )}
      </ButtonBase>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{ boxShadow: 'none' }}
      >
        <Stack pb={1}>
          <MenuItem>
            <Link href={PATH_ACCOUNT}>
              <Stack direction='row' alignItems='center' gap={1.5}>
                <Image src='/user.svg' width={16} height={16} alt='user' />
                <Typography color='#111111' fontSize={14} fontWeight={500}>
                  アカウント情報
                </Typography>
              </Stack>
            </Link>
          </MenuItem>
        </Stack>
        <MenuItem
          sx={{ borderTop: '1px solid #DDDDDD', pt: 2, px: 2 }}
          onClick={async () => await signOut()}
        >
          <Stack direction='row' alignItems='center' gap={1.5}>
            <LogoutIcon fontSize='small' />
            <Typography color='#111111' fontSize={14} fontWeight={500}>
              ログアウト
            </Typography>
          </Stack>
        </MenuItem>
      </Menu>
    </>
  )
}
